import { FlatActionList, Text } from "@towersystems/roam-common-native";
import { Sale } from "@towersystems/roam-common/lib/generated-types";
import { formatDateToCalendar } from "@towersystems/roam-common/lib/shared-utils";

export interface SaleLaybySummaryProps {
  sale: Sale;
}
export const SaleLaybySummary = ({ sale }: SaleLaybySummaryProps) => {
  if (sale.saleType !== "LAYBY") {
    return null;
  }
  return (
    <FlatActionList
      items={[
        {
          key: "expectedPickupDate",
          title: "Expected Pickup Date",
          componentRight: () => (
            <Text variant="heading1">
              {sale.expectedPickupDate
                ? formatDateToCalendar(sale.expectedPickupDate)
                : "-"}
            </Text>
          ),
        },
      ]}
    />
  );
};
